import { z } from "zod"
import { latitudeSchema, longitudeSchema } from "../util"
import { missionTableMissionItemSchema } from "./mission-table"
import { customFieldAnswerSchema } from "./mission-custom-fields"

export const updatableMissionSchema = z.object({
    notes: z.string().nullable().optional(),
    aircraftId: z.string().nullable().optional(),
    userId: z.string().nullable().optional(),
})

export type UpdatableMission = z.infer<typeof updatableMissionSchema>

export const getMissionResponseSchema = missionTableMissionItemSchema.nullable()
export type GetMissionResponse = z.infer<typeof getMissionResponseSchema>
export const batchDeleteMissionsBodySchema = z.object({ ids: z.array(z.string()) })
export type BatchDeleteMissionsBody = z.infer<typeof batchDeleteMissionsBodySchema>

export const batchAssignAircraftBodySchema = z.object({
    ids: z.array(z.string()),
    aircraftId: z.uuid().nullable(),
})
export type BatchAssignAircraftBody = z.infer<typeof batchAssignAircraftBodySchema>

export const batchAssignPilotBodySchema = z.object({
    ids: z.array(z.string()),
    userId: z.guid().nullable(),
})
export type BatchAssignPilotBody = z.infer<typeof batchAssignPilotBodySchema>

export const batchEditMissionDetailsBodySchema = z.object({
    ids: z.array(z.string()).min(1),
    notes: z.string().optional(),
    takeoffLatitude: latitudeSchema.optional(),
    takeoffLongitude: longitudeSchema.optional(),
    customFieldAnswers: z.array(customFieldAnswerSchema).optional(),
})
export type BatchEditMissionDetailsBody = z.infer<typeof batchEditMissionDetailsBodySchema>

export const missionLogsHeatmapQuerySchema = z.object({
    userId: z.guid().optional(),
    aircraftId: z.uuid().optional(),
    from: z.coerce.date().optional(),
    to: z.coerce.date().optional(),
})
export type MissionLogsHeatmapQuery = z.infer<typeof missionLogsHeatmapQuerySchema>

export const missionLogsHeatmapPointSchema = z.object({
    lat: z.number(),
    lng: z.number(),
    weight: z.number(),
})
export type MissionLogsHeatmapPoint = z.infer<typeof missionLogsHeatmapPointSchema>

export const createManualMissionBodySchema = z.object({
    aircraftId: z.uuid(),
    userId: z.guid(),
    startedAt: z.iso.datetime(),
    endedAt: z.iso.datetime().optional(),
    takeoffLatitude: latitudeSchema.optional(),
    takeoffLongitude: longitudeSchema.optional(),
    locationName: z.string().optional(),
    notes: z.string().optional(),
    flightPath: z.array(z.tuple([longitudeSchema, latitudeSchema])).optional(),
    signalQuality: z.number().int().min(0).max(5).optional(),
    takeoffBatteryPercent: z.number().min(0).max(100).optional(),
    landingBatteryPercent: z.number().min(0).max(100).optional(),
    customFieldAnswers: z.array(customFieldAnswerSchema).optional(),
})
export type CreateManualMissionBody = z.infer<typeof createManualMissionBodySchema>
